import { useStyles } from './styles';
import { Box } from '@material-ui/core';
import { insertActivityLog } from '../../actions';
import { getAppSource, getUserType } from '../../helpers';
import { useState } from 'react';
import PhoneIcon from '@material-ui/icons/Phone';
import { useSelector } from 'react-redux';
import { LeavingSiteConfirmation } from '../../components';
import Cookies from 'js-cookie';

export const RefinanceCard = (props) => {

  const { bannerBody, bannerImageUrl, bannerTitle,
    buttonColor, buttonText, buttonURL, titleBgColor, bannerSubTitle, bannerName, refiCompany, taxBannerBody } = props.banner;
  const theme = useSelector(state => state.theme);
  const {lendingNumber} = theme;
  const [popupStatus, setPopup] = useState(false);
  const classes = useStyles();

  const refinance = {
    ctaGrid: {
      display: 'grid',
      gap: '12px',
      padding: '1.2em 2.4em 1.2em'
    },
    ctaRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      width: '100%',
      border: '2px solid #e5e7eb',
      borderRadius: '12px',
      background: '#ffffff',
      padding: '10px 12px',
      textDecoration: 'none',
      cursor: 'pointer',
      textAlign: 'left'
    },
    ctaIcon: {
      width: '42px',
      height: '42px',
      borderRadius: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0
    },
    ctaContent: {
      minWidth: 0
    },
    ctaTitle: {
      color: '#111827',
      fontFamily: 'Montserrat',
      fontSize: '16px',
      fontWeight: 700,
      lineHeight: 1.2
    },
    ctaDesc: {
      color: '#4b5563',
      fontFamily: 'Montserrat',
      fontSize: '13px',
      fontWeight: 500,
      lineHeight: 1.3,
      marginTop: '2px'
    },
    ctaPhone: {
      color: '#0f766e',
      fontFamily: 'Montserrat',
      fontSize: '14px',
      fontWeight: 700,
      lineHeight: 1.2,
      marginTop: '2px'
    }
  };

   const route = () => {
    setPopup(true)
  }

  const sendActivityData = async () => {
    const remark = `User clicked on Continue button after clicking Apply Now button on refinance tile(${refiCompany}) on home page of MLW.`;
    const data = {
      "accountNumber":  Cookies.get("selectedAccount"),
      "activityCode": "UAL202",
      "activityStatus": "Success",
      "action": refiCompany,
      "controller": "Dashboard",
      "apiName": "GetAccountInfo",
      "activityRemark":  remark,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": "",
    };

    await insertActivityLog(data);
  }

  const handleOk = () => {
    setPopup(false)
    sendActivityData()
    window.open('https://bsifinancialrefinanceonline.mymortgage-online.com/', '_blank') 
  }

  return (
    <>
    <Box className={classes.root}>
      <Box className={classes.body}>
        <img className={classes.logo} src={bannerImageUrl} alt='banner logo' />
        <Box className={classes.bodyText} dangerouslySetInnerHTML={{ __html: bannerBody }}></Box>
      </Box> 

      <div style={refinance.ctaGrid}>
        <button
          style={refinance.ctaRow}
          onClick={() => route()}
        >
          <div style={{ ...refinance.ctaIcon, background: '#eff6ff' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
          </div>
          <div style={refinance.ctaContent}>
            <div style={refinance.ctaTitle}>{buttonText}</div>
            <div style={refinance.ctaDesc}>Start your application online</div>
          </div>
        </button>

        <a href={`tel:${lendingNumber}`} style={refinance.ctaRow}>
          <div style={{ ...refinance.ctaIcon, background: '#f0fdfa' }}>
            <PhoneIcon style={{ fontSize: 24, color: '#0f766e' }} />
          </div>
          <div style={refinance.ctaContent}>
            <div style={refinance.ctaTitle}>Call a Loan Officer</div>
            <div style={refinance.ctaPhone}>{lendingNumber}</div>
          </div>
        </a>

        <button
          onClick={() => props?.handleContactMe()}
          style={{ ...refinance.ctaRow, border: '2px solid #e5e7eb' }}
        >
          <div style={{ ...refinance.ctaIcon, background: '#fef3c7' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#d97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/></svg>
          </div>
          <div style={refinance.ctaContent}>
            <div style={refinance.ctaTitle}>Request a Callback</div>
            <div style={refinance.ctaDesc}>{taxBannerBody}</div>
          </div>
        </button>
      </div>
    </Box>
    <LeavingSiteConfirmation 
        open={popupStatus}
        handleClose={() => setPopup(false)}
        handleOk={handleOk}
      />
    </>  
  )
}
